import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import Stack from '@mui/material/Stack';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import { croPerfomanceAnalyticsTableHeader } from './utils/croPerfomanceAnalyticsTableHeader';
import { getCroPerfomanceAnalytics, getReportingUnderHead } from '../../../../redux/features/crdMigrationSlice';
import { getCourses } from '../../../../redux/features/crmSlice';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import GlobalTableNoPagination from '../../../../components/CustomTableWithPagination/GlobalTableNoPagination';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';

export default function CroPerfomanceAnalytics() {
  // normal variable
  const dispatch = useDispatch();

  // Redux State-------------------------------------------------------------
  //
  const loading = useSelector((state) => state.crdMigration.croPerfomanceAnalyticsTable.loading);
  const croPerfomanceAnalyticsTable = useSelector((state) => state.crdMigration.croPerfomanceAnalyticsTable.data);
  const coursesPreData = useSelector((state) => state.crm.coursesPreData);
  const reportingUnderHeadLoading = useSelector((state) => state.crdMigration.reportingUnderHead.loading);
  const reportingUnderHeadData = useSelector((state) => state.crdMigration.reportingUnderHead.data);
  const courseLoading = useSelector((state) => state.crm.loading);
  //
  //--------------------------------------------------------------------------

  // react state
  const [fromDate, setFromDate] = useState(dayjs().startOf('year').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(dayjs().endOf('year').format('YYYY-MM-DD'));
  const [reportingHead, setReportingHead] = useState({ id: 0, value: '' });
  const [course, setCourse] = useState({ courseId: -1, courseName: 'All' });
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: 'asc' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  // EXCEPT CRO ---------------------------------------------
  useEffect(() => {
    dispatch(getCourses());
    dispatch(getReportingUnderHead());
  }, [dispatch]);
  // ---------------------------------------------------------

  //---------- DispatchParams ---------------------------------
  const dispatchParams = useMemo(
    () => ({
      from_date: fromDate,
      to_date: toDate,
      course_selected: course?.courseId ?? -1,
      reporting_head_selected: reportingHead?.id,
    }),
    [fromDate, toDate, course, reportingHead],
  );

  //---------* =-=-=-==-=--=-=-=-=- *---------------------------

  //-------------- Table Fetch ------------------------------
  useEffect(() => {
    dispatch(getCroPerfomanceAnalytics(dispatchParams));
  }, [dispatchParams, dispatch]);
  //-------------* Table Fetch *-----------------------------

  const styleString = `tbody tr:first-child {
    font-weight : 700 ;
    background : #b8ae89;
    }`;

  const totalValueRow = useMemo(() => {
    if (!croPerfomanceAnalyticsTable?.total || !Object.keys(croPerfomanceAnalyticsTable?.total).length) return {};

    return Object.entries(croPerfomanceAnalyticsTable?.total).reduce(
      (acc, [key, value]) => {
        acc[key.slice(6)] = value;
        return acc;
      },

      {},
    );
  }, [croPerfomanceAnalyticsTable]);

  return (
    <GlobalWrapper title={'CRO Perfomance Analytics'}>
      <Stack gap={2}>
        <Stack direction={{ xs: 'column', md: 'row' }} gap={1}>
          <FromAndToDatePicker
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            fullWidth
          />
          <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
            <Autocomplete
              id="combo-box-demo"
              getOptionLabel={({ courseName }) => courseName ?? ''}
              isOptionEqualToValue={(opt, val) => opt?.courseId === val?.courseId}
              options={coursesPreData ?? []}
              onChange={(_, v) => setCourse(v)}
              sx={{ width: { xs: '100%', lg: 300 } }}
              renderInput={(params) => <TextField {...params} label="Course" />}
              loading={courseLoading}
            />
            <GlobalSelectFieldWithoutFormikNew
              data={[{ reporting_head: 0, name: 'All' }, ...reportingUnderHeadData]}
              disabled={reportingUnderHeadLoading}
              label={'Reporting Head'}
              keys={{
                itemId: 'reporting_head',
                itemValue: 'name',
              }}
              selectedDetails={reportingHead}
              setChange={setReportingHead}
              sx={{
                width: { xs: '100%', lg: 300 },
              }}
            />
          </Stack>
        </Stack>
        <GlobalTableNoPagination
          headers={croPerfomanceAnalyticsTableHeader}
          tableState={tableState}
          setTableState={setTableState}
          loading={loading}
          rows={croPerfomanceAnalyticsTable?.cro || []}
          permanentFirstRow={{ ...totalValueRow, name: 'Total' }}
          customeStyleString={styleString}
        />
      </Stack>
    </GlobalWrapper>
  );
}
